(function () {
  jQuery(document).on("fileuploadprogressall", function (e, data) {
    var progress;
    var target = jQuery(e.target);
    var counter = target.siblings(".progress_count");
    progress = parseInt((data.loaded / data.total) * 100, 10);
    counter.html('<span class="progress"></span>');
    return counter.find(".progress").css("width", progress + "%");
  });

  jQuery(document).on("fileuploadstop", function (e, data) {
    return $(".progress_count").hide();
  });

  jQuery(document).on("fileuploadsend", function (e, data) {
    return $(".progress_count").show();
  });
}).call(this);
